var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "raft-checkbox",
    attrs: {
      "for": _vm.id
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "aria-label": _vm.label,
      "data-cy": _vm.cy
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.checkedStatus
  }, [_c('span')]), _vm._v(" "), _c('span', {
    staticClass: "checkbox-label",
    class: _vm.isLabelHidden ? 'hidden' : ''
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._t("custom-checkbox-content")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }